export default __webpack_public_path__ + "static/media/avaya-onecloud-top-logo.c9a74c99.svg";